import React from "react";
import { Wrapper } from "./Select.styled";
import { CaretDownOutlined } from "@ant-design/icons";
import { Button } from "../Button/Button";
import { Select } from "antd";

export const Select_ = ({
    defaultValue,
    placeholder,
    mode,
    allowClear,
    onChange,
    options,
    name,
    level,
    disabled,
    location,
    buttonTitle,
    nameValue,
    value,
    showSearch,
    onSelect,
    onDeselect,
    style,
}) => {
    const { Option } = Select;
    return (
        <Wrapper
            style={style}
            defaultValue={defaultValue}
            placeholder={placeholder}
            mode={mode}
            allowClear={allowClear}
            onChange={onChange}
            suffixIcon={<CaretDownOutlined />}
            showArrow
            showSearch
            value={value}
            onSelect={onSelect}
            disabled={disabled}
            filterOption={(input, option) => {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
        >
            {options?.map((value, index) => {
                return (
                    <Option key={index} value={value?.id} label={name ? value?.name : level ? value?.Level : `${value?.name} , ${value.state}`}>
                        {name && <div>{value?.name}</div>}
                        {level && <div>{value?.Level}</div>}
                        {nameValue && <div>{value?.value}</div>}
                        {location && (
                            <div>
                                {value?.name} , {value.state}
                            </div>
                        )}
                    </Option>
                );
            })}
        </Wrapper>
    );
};
